export const Cardiovascular = {
    problems: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
};
